module.exports = __webpack_public_path__ + "media/images/emblems/Saxeten-coat_of_arms-5a6b5122bfed54e7b22aefa9d008fbf6.svg";